import { formatNumber } from "utils/formatNumber";

export const simpleNumberFormatter = (value: number | null | undefined) => {
  if (value !== null && value !== undefined && !Number.isNaN(value)) {
    return formatNumber(value, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    });
  }
  return "-";
};
